export default __webpack_public_path__ + "static/media/icon_zone_control_8.e7f97815.png";